import React, { Fragment } from "react";
import { lazyWithRetry } from "../../core/lazy_with_retry";

import { ImageData } from "../../data";
import { OfferingDetailsDayPassWithCapacity } from "../template_offering_details_daypass_with_capacity";
import { useCubicoAnalytics } from "./cubico_analytics";
import {
  generalInfo,
  partnerConfig,
  testimonials,
} from "./cubico_partner_config";

const Theme = lazyWithRetry(() => import("./cubico_theme"));

const faqs = [
  {
    question: "Can I change the date of my daily office booking?",
    answer:
      "Yes, please call us or reply to the confirmation email and we can assist you with your updates.",
  },

  {
    question: "Can I share my day office booking with other people?",
    answer:
      "Yes, the daily office booking is for you and your team. Please use the invite during confirmation to let us know who the other attendees are.",
  },
];

const cubicoDailyOfficeSOHODesktopImages: ImageData[] = [
  {
    url: "https://meet-production.s3.amazonaws.com/images/location_image/image/ab55be9d-5ca8-45ff-ab14-03c069d63fa2/medium_CubicoOffice.jpg",
    width: 5328,
    height: 2997,
  },
  {
    url: "https://meet-production.s3.amazonaws.com/images/location_image/image/99f3eba3-78c1-4ebe-8be9-a272fa09d49a/medium_02-2016AV15.4141.jpg",
    width: 1200,
    height: 800,
  },
  {
    url: "https://meet-production.s3.amazonaws.com/images/location_image/image/171a07ab-2215-4116-8184-13b012c943f2/medium_01-2016AV15.4301.jpg",
    width: 1200,
    height: 800,
  },
];

const cubicoDailyOfficeSOHOMobileImages: ImageData[] =
  cubicoDailyOfficeSOHODesktopImages;

export function OfferingCubicoDailyOffice() {
  useCubicoAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsDayPassWithCapacity
        showAddress={false}
        showDirections
        getDesktopImagesBasedOnLocation={() => {
          return cubicoDailyOfficeSOHODesktopImages;
        }}
        getMobileImagesBasedOnLocation={() => {
          return cubicoDailyOfficeSOHOMobileImages;
        }}
        partnerConfig={partnerConfig}
        data={{
          description:
            "Book a private office and enjoy the benefits of coworking for the day.",
          testimonials: testimonials,
          faqs: faqs,
          generalInfo,
        }}
      />
    </Fragment>
  );
}
